<template>
  <div class="qr-scan-hint">
    <span class="qr-scan-hint__icon">
      <BaseIcon name="camera" size="15" />
    </span>
    <div class="qr-scan-hint__text">
      <strong>{{ $t('invoices.payment_link.scan_with_camera') }}</strong>
      <span>{{ $t('invoices.payment_link.scan_not_bank_app') }}</span>
    </div>
  </div>
</template>

<script>
  import BaseIcon from '@shared/components/BaseIcon.vue';

  export default {
    name: 'QrScanHint',

    components: { BaseIcon },
  };
</script>

<style scoped lang="scss">
  .qr-scan-hint {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    padding: 0 0.25rem;
    text-align: left;

    &__icon {
      flex-shrink: 0;
      margin-top: 1px;
      color: var(--brand-600);
    }

    &__text {
      display: flex;
      flex-direction: column;
      gap: 0.0625rem;
      min-width: 0;

      strong {
        font-size: 0.8125rem;
        font-weight: 600;
        color: var(--slate-900);
      }

      span {
        font-size: 0.75rem;
        line-height: 1.4;
        color: var(--slate-600);
      }
    }
  }
</style>
